import { simplifiedConcurrency } from 'simplified-concurrency';
const paths = new Map();
/**
 * Make the concurrency be per-path to allow multiple documents to be loaded and updated at the same time, just keeping
 * each document's operations sequential.
 */
export function concurrency(path) {
    let concurrency = paths.get(path);
    if (!concurrency) {
        concurrency = simplifiedConcurrency();
        paths.set(path, concurrency);
    }
    return concurrency;
}
export function blockableByPath(fn) {
    return function (...args) {
        return concurrency(args[0]).blockFunction(fn, args, this);
    };
}
